import axios from "axios";
import { objectToFormData } from "../utils/helpers";
import Api from "./axios";

export const getLL55Compliance = async (keys) => {
  return await Api.get(`/v1/ll55/compliance${keys}`);
};

export const addLL55Compliance = async (data) => {
  return await Api.post(`/v1/ll55/compliance`, data);
};

export const downloadll55PendingMailer = async (data) => {
  return await Api.post(`/v1/ll55/download-pending-mailer`, data);
};

export const getLL55SurveyDetails = async (survey_id,token) => {
  return await Api.get(`/v1/ll55/by-survey/${survey_id}`, {
    headers: token ? { authorization: `Bearer ${token}` } : {},
  });
};

export const updateLL55SurveyResponse = async ({ survey_id, data, token }) => {
  return await Api.put(`/v1/ll55/update_by_survey`, objectToFormData(data), {
    headers: token ? { authorization: `${token}` } : {},
  });
};

export const scanLl55SurveyCompliance = async ({ survey_id, data, token }) => {
  return await axios.put(
    `${process.env.REACT_APP_BASE_URL}/v1/ll55/survey`,
    objectToFormData(data),
    {
      headers: token ? { authorization: `${token}` } : {},
    }
  );
};

export const ll55ReportUpload = async (body) => {
  return await Api.post(`/v1/ll55/report-upload`, objectToFormData(body));
};

export const ll55ReportDelete = async (id, type) => {
  return await Api.put(
    `/v1/ll55/report-deleted?ll55_id=${id}&report_type=${type}`
  );
};

export const downloadLl55SurveyForm = async (data) => {
  return await Api.post(`/v1/ll55/downloadSurveyForm`, data);
};

export const downloadLl55AuditReport = async (data) => {
  return await Api.post(`/v1/ll55/downloadAuditReport`, data);
};